/**
 *  底层基本函数 
 *  @module base/mabse
 */
import Dom from './mdom.js';
import throttle from 'lodash.throttle';

export var isCSR = typeof __VUE_SSR_CONTEXT__ !== 'undefined';
export function getCSR() {return __VUE_SSR_CONTEXT__}

/**
 *  生成随机的key
 *  @public
 *  @param  _asPrefix   前缀,用于区别
 *
 *  @return 一个随机生成的key
 *  @example
 *
 *  var data = uinkey('test');
 *  console.log(data); //test7389232938012801,类似这样
 *
 */
export function unikey(_asPrefix) {
    return [_asPrefix, 'f', Math.random()].join("").split(".").join("");
}

/**
 *  扩展一个对象，并返回扩展后的对象
 *  @public
 *  @desc  
 *      arguments[0] 目标元素;
 *      arguments[1，2，.....n]   为被扩展的对象，就是把这些对象的属性及值浅拷贝到 arguments[0]
 *  @return
 *  @example
 *  var a = {'src':3,'src1':4};
 *  var b = extend(a,{'src22':33},{'src223':33},{'src224':33});
 *  b = {
 *      'src':3,'src1':4,
 *      'src22':33,
 *      'src223':33,
 *      'src224':33
 *  }
 *
 */
export function extend() {
    for (var _oArgs = arguments, _oDesc = _oArgs[0], i = 1, _nLen = _oArgs.length; i < _nLen; i++) {
        var _oSrce = _oArgs[i];
        for (var j in _oSrce) {
            _oDesc[j] = _oSrce[j];
        }
    }
    return _oDesc;
}

const SafeQueryStringChecker = {
    checkQueryKeyMap: {},
    SafeQueryKeyWhiteList: [
        "uin", "pass_ticket", "key", "access_token", "noticeid", "act_id", "rpt_allpath", "wechat_immersive", "wechat_pkgid", "abt", "appid"
    ],
    checkValueIsSafe(key, value) {
        if( SafeQueryStringChecker.SafeQueryKeyWhiteList.find(k => k === key) ) {
            return;
        }
        if( !value ) {
            return;
        }
        if (key in SafeQueryStringChecker.checkQueryKeyMap) {
            return;
        }
        SafeQueryStringChecker.checkQueryKeyMap[key] = {
            checked: false,
            value: value
        };
        SafeQueryStringChecker.checkValueIsSafeDebounced(key, value)
    },
    checkValueIsSafeDebounced: throttle(() => {
        setTimeout(() => {
            Object.keys(SafeQueryStringChecker.checkQueryKeyMap).forEach(key => {
                let checkItem = SafeQueryStringChecker.checkQueryKeyMap[key]
                if ( checkItem.checked === true) {
                    return;
                }
                checkItem.checked = true;
                let value = decodeURIComponent(checkItem.value);
                if (/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi.test(value) ) {
                    console.error(`通过queryString获取到的值为中文字符，请安全使用。key 为 ${key}`);
                    if( WXGAME?.baseQualityReport ) {
                        WXGAME.baseQualityReport.StartLogic(
                            WXGAME.baseQualityReport.LOGIC_CONST.TypeTextEnum.EEVEE,
                            "query_contains_chinese", 
                            {
                                value: value
                            }
                        ).EndLogic({
                            err_msg: key
                        })
                    }
                }else if( /^(https?:)?\/\//.test(value) ) {
                    console.error(`通过queryString获取到的值为链接，请安全使用。key 为 ${key}`);
                    if( WXGAME?.baseQualityReport ) {
                        WXGAME.baseQualityReport.StartLogic(
                            WXGAME.baseQualityReport.LOGIC_CONST.TypeTextEnum.EEVEE,
                            "query_contains_url", 
                            {
                                value: value
                            }
                        ).EndLogic({
                            err_msg: key
                        })
                    }
                }
            })
        }, 200)
    }, 2000, {
      trailing: false,
    })
}

/**
 *  获取url中的某个key对应的值
 *  @public
 *  @param   {string} name      key名
 *  @param   {string} str       需要被搜索的字符串（默认为 content.location.href ）
 *  @param   {object} content   上下文的环境（默认为 当前的window）
 *  @returns {string}
 *  @example
 *  location.href = 'http://www.qq.com/r.cgi?te=32&tags=div';
 *  var te = getQueryStr('te'); // te = 32
 *  var tags = getQueryStr('tags'); // te = div
 *
 */
export function getQueryStr(name, str, context) {
    var _str = str;
    if(!isCSR) {
        if( undefined === context ){
            context = window;
        }
        if(undefined === context.location){
            throw  'Illegal Context,Need context.location';
        }
        _str = str || context.location.search;
    }else{
        // 如果ssr且未传入str，则直接用query
        if(!str){
           return getValue(getCSR(), 'query.' + name);
        }
    }
    //先去除一下hash
    _str = ('' + _str).replace(/#(.*)$/g, '').replace(/&amp;/g, '&');
    var res = _str.match(new RegExp("[\?\&]" + name + "=([^\&]+)", "i"));
    if (res == null || res.length <= 1) {
        return "";
    }

    if( !str ) { // 没有传str，说明是location.search场景，需要做检测   
        SafeQueryStringChecker.checkValueIsSafe(name, res[1])
    }
    return res[1];
}

function decode(str) { 
    return decodeURIComponent(str.replace(/\+/g, " ")); 
}

export function getAllQueryStr(str, context) {
    var _str = str;
    if(!isCSR) {
        if( undefined === context ){
            context = window;
        }
        if(undefined === context.location){
            throw  'Illegal Context,Need context.location';
        }
        _str = str || context.location.search;
    }else{
        // 如果ssr且未传入str，则直接用query
        if(!str){
           return getValue(getCSR(), 'query');
        }
    }
    //先去除一下hash
    _str = ('' + _str).replace(/#(.*)$/g, '').replace(/&amp;/g, '&');
    let splits = _str.split("?")
    let query = splits.length >= 2 ? splits[1]: '';
    let params = {};
    let reg = /([^&=]+)=?([^&]*)/g
    let result;
    while( result = reg.exec(query) ) {
        let key = decode(result[1]);
        let value = decode(result[2])
        params[key] = value
        SafeQueryStringChecker.checkValueIsSafe(key, value)
    }
    return params
}

/**
 * 删除url查询参数里面的某个key
 * @public
 * @param {string} name key名
 * @param {string} url 
 * @returns {string} 删除key后的url
 * @example
 * var url = removeQueryStringKey('key', 'https://qq.com/index.html?key=123&abt=1') // https://qq.com/index.html?abt=1
*/
export function removeQueryStringKey(key, url) {
    var _url = url || location.href;
    var regexp = new RegExp("([\?\&])" + key + "=([^\&]*)&?", "i");
    return _url.replace(regexp, "$1")
}

export function appendQueryStr(uri, key, value) {
    if(!value) {
        return uri;
    }
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
        var separator = uri.indexOf('?') !== -1 ? '&' : '?';
        var hash = uri.split('#');
        uri = hash[0] + separator + key + '=' + value;
        if ( hash[1] ) {
            uri += '#' + hash[1];
        }
        return uri;
    }
}

export function log(str){
	(new Image()).src = 'https://game.weixin.qq.com/favicon.ico?ts=' + (new Date()).getTime() + '&log=' + encodeURIComponent(str);
}

function createNamespace(_asName) {
    var _oArr = _asName.split('.'),
        _oSpace = window,
        _sName;
    for (var i in _oArr) {
        _sName = _oArr[i];
        !_oSpace[_sName] && (_oSpace[_sName] = {});
        _oSpace = _oSpace[_sName];
    }
    return _oSpace;
}

export function buildAPI(_asName, _aoData) {
    var _oFunc = null,
        _mbiOS = /(iPhone|iPad|iPod|iOS)/i.test(Dom.window.navigator.userAgent),
        _mbAndroid = /(Android)/i.test(Dom.window.navigator.userAgent),
        _nIndex = _asName.lastIndexOf('.'),
        _oNS = createNamespace(_asName.substring(0, _nIndex));
    if (_aoData.iOS && _mbiOS) {
        _oFunc = _aoData.iOS;
    } else if (_aoData.android && _mbAndroid) {
        _oFunc = _aoData.android;
    } else {
        _oFunc = function () {};
        //alert('get os error : ' + _asName);
    }
    _oNS[_asName.substring(_nIndex + 1)] = _oFunc;
}



/* 
    专门用于获取 json值，不想再出现 使用a.b.c.d时，因为b == undefined, 我们取c就直接报错了。
    用法： var json = { key1:23,key2:{ key3:{key4:5}}};
    getValue(json,"key1") => 23;
    getValue(json,"key2.key3") => {key4:5};
    getValue(json,"key2.keya.ag") => undefined  keya不存在，但它再也不报错了。
*/
export function getValue(json,jsonDotStr){
    var layKeys = jsonDotStr.split('.');
    var tjson = json || {},
        tkey = null;
    while( tkey = layKeys.shift() ){
        if('undefined' === typeof tjson[tkey] || null === tjson[tkey]){
            return undefined;
        }
        tjson = tjson[tkey];
    }
    return tjson;
}

export function S(str,context){
    var win = context || Dom.window;
    return win.document.getElementById(str);
}

export function SCN(str,context){
    var win = context || Dom.window;
    return win.document.getElementsByClassName(str);
}
export function STN(str,context){
    var win = context || Dom.window;
    return win.document.getElementsByTagName(str);
}

export function hexColor2GrayColor(c) {
    const color = c.toLowerCase();
    if( color && /^#([0-9a-f]{3}|[0-9a-f]{6})$/.test(color) ) {
        let rgbList = [];
        if( color.length === 4 ) {
            for (var i = 1; i<= 3; i++ ) { 
                let val = color.slice(i, i + 1);
                rgbList.push(`0x${val}${val}`);
            }
        }else {
            for (var i = 1; i <= 6; i = i + 2 ) { 
                rgbList.push(`0x${color.slice(i, i+2)}`);
            }
        }
        let gray = Math.floor((rgbList[0] * 299 + rgbList[1] * 587 + rgbList[2] * 114 ) / 1000);
        let grayHex = gray.toString(16);
        return `#${grayHex}${grayHex}${grayHex}`;
    }
    return color;
}

export function rgbToHsl(rgb) {
    let r = rgb[0] / 255;
    let g = rgb[1] / 255;
    let b = rgb[2] / 255;

    let max = Math.max(r, g, b);
    let min = Math.min(r, g, b);

    let h, s, v = max;
    let d = max - min;

    s = max === 0 ? 0 : d / max;

    if (max === min) {
        h = 0; // achromatic
    } else {
        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);

                break;
            case g:
                h = (b - r) / d + 2;

                break;
            case b:
                h = (r - g) / d + 4;

                break;
        }
        h /= 6;
    }

    var l = (2 - s) * v / 2;
    if (l != 0) { 
        if (l == 1) { 
            s = 0        
        } else if (l < 0.5) {
            s = s * v / (l * 2)        
        } else {
            s = s * v / (2 - l * 2)        
        }    
    }

    return [Math.round(h * 360), Math.round(s * 100), Math.round(l * 100)];
}

export default {
    S       : S,
    SCN     : SCN,
    STN     : STN,
    getValue:getValue,
    extend: extend,
    unikey: unikey,
    log   : log,
    getQueryStr: getQueryStr,
    getAllQueryStr: getAllQueryStr,
    removeQueryStringKey: removeQueryStringKey,
    buildAPI: buildAPI,
    isCSR : isCSR,
    getCSR: getCSR,
    hexColor2GrayColor: hexColor2GrayColor,
    rgbToHsl: rgbToHsl
};
